import Actions from './actions.js';

const rowsModule = serviceClient => {
  const actions = Actions(serviceClient);
  return {
    namespaced: true,
    actions
  };
};

export default rowsModule;
